module.exports = __webpack_public_path__ + "static/media/penguins.88e32609.mp4";